import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext"; 
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { 
//     loadCaptchaEnginge, 
//     LoadCanvasTemplate, 
//     validateCaptcha 
// } from 'react-simple-captcha';
import "./login.css";

const Login = () => {
    const { login } = useAuth();
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    // const [captcha, setCaptcha] = useState(""); 

    useEffect(() => {
        // loadCaptchaEnginge(6); 
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // if (!validateCaptcha(captcha)) {
        //     toast.error("❌ Invalid Captcha!", {
        //         position: "top-right",
        //         autoClose: 2000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: true,
        //         theme: "colored",
        //     });
        //     return; 
        // }

        const success = await login(username, password);

        if (success) {
            toast.success("✅ Login Successfully!", {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
            });

            setTimeout(() => {
                navigate("/dashboard");
            }, 1000);
        } else {
            toast.error("❌ Invalid username or password!", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
            });
        }
    };

    return (
        <div className="loginContainer">
            <ToastContainer />
            <div className="loginCard">
                <h2>Login</h2>
                <form onSubmit={handleSubmit}>
                    <div className="inputGroup">
                        <label>Username</label>
                        <input
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="inputGroup">
                        <label>Password</label>
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    {/* Captcha Section */}
                    {/* <div className="captchaGroup inputGroup">
                        <LoadCanvasTemplate />
                        <input
                            type="text"
                            placeholder="Enter Captcha"
                            value={captcha}
                            onChange={(e) => setCaptcha(e.target.value)}
                            required
                        />
                    </div> */}

                    <div className="forgotPassword">
                        <a href="/forgetPassword">Forgot Password?</a>
                    </div>
                    <button type="submit" className="loginBtn">Login</button>
                </form>
            </div>
        </div>
    );
};

export default Login;
